import { Button } from "@thilke/ui/components/button";
import { Panel } from "@thilke/ui/components/panel";
import { cn } from "@thilke/ui/lib/utils";
import type * as React from "react";
export interface WorkspaceShellBlockProps
  extends React.ComponentProps<"section"> {
  title?: string;
}

function WorkspaceShellBlock({
  title = "Workspace",
  className,
  ...props
}: WorkspaceShellBlockProps) {
  return (
    <section
      data-slot="workspace-shell-block"
      className={cn(
        "grid min-h-80 overflow-hidden rounded-lg border bg-background text-foreground md:grid-cols-[64px_180px_1fr]",
        className,
      )}
      {...props}
    >
      <aside className="hidden border-r bg-card p-2 md:grid md:content-start md:gap-2">
        {["⌘", "S", "F", "A"].map((item) => (
          <div
            key={item}
            className="grid size-10 place-items-center rounded-md border bg-background text-xs font-semibold text-muted-foreground"
          >
            {item}
          </div>
        ))}
      </aside>
      <aside className="hidden border-r bg-card/80 p-3 md:grid md:content-start md:gap-2">
        <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
          Projects
        </div>
        {["Encounter", "Compendium", "Notes"].map((item) => (
          <div
            key={item}
            className="rounded-md px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground"
          >
            {item}
          </div>
        ))}
      </aside>
      <main className="grid gap-3 p-4">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-lg font-semibold tracking-tight">{title}</h3>
            <p className="text-sm text-muted-foreground">
              Adapted from devl.dev layout/app-shell block patterns.
            </p>
          </div>
          <Button size="sm">New scene</Button>
        </div>
        <div className="grid gap-3 md:grid-cols-2">
          <Panel position="docked">
            <div className="text-sm font-medium">Scene Canvas</div>
            <div className="mt-8 rounded-md border border-dashed p-8 text-center text-xs text-muted-foreground">
              drop tokens here
            </div>
          </Panel>
          <Panel position="docked">
            <div className="text-sm font-medium">Inspector</div>
            <div className="mt-2 grid gap-2 text-xs text-muted-foreground">
              <span>Status: ready</span>
              <span>Mode: edit</span>
              <span>Sync: online</span>
            </div>
          </Panel>
        </div>
      </main>
    </section>
  );
}

export { WorkspaceShellBlock };
